import { component } from 'picoapp'
import '@/lib/jquery-global.js';
import 'slick-carousel';

export default component((node, ctx) => {

    
    if (node.querySelector('.js-favorites')) {
        const slider = jQuery(node.querySelector('.js-favorites'))
  
        slider.slick({
            dots: false,
            arrows: false,
            draggable: true,
            swipe: true
        });
    }

})
